import Axios from "../../Utils/Interceptors";

Axios.defaults.withCredentials = true;
// Función para hacer una solicitud GET
export async function GET(url, params = {}, headers = {}, axiosConfig = {}) {
  // console.log(url);
  const response = await Axios.get(url, {
    params: params,
    headers: headers,
    ...axiosConfig,
  });

  return response.data;
}

// Función para hacer una solicitud POST
export async function POST(url, body = {}, headers = {}, axiosConfig = {}) {
  const response = await Axios.post(url, body, {
    headers: headers,
    ...axiosConfig,
  });

  return response.data;
}

// Función para hacer una solicitud PUT
export async function PUT(url, body = {}, headers = {}) {
  const response = await Axios.put(url, body, {
    headers: headers,
  });
  return response.data;
}

// Función para hacer una solicitud DELETE
export async function DELETE(url, params = {}, headers = {}) {
  const response = await Axios.delete(url, {
    params: params,
    headers: headers,
  });
  return response;
}
